export const MEDIA_TYPES = {
  news: "news",
  social: "social",
  twitter: "twitter",
  conflict: "conflict",
};
